import { render, staticRenderFns } from "./AutomaticProjectIssuesList.vue?vue&type=template&id=409b9097&scoped=true"
import script from "./AutomaticProjectIssuesList.vue?vue&type=script&lang=js"
export * from "./AutomaticProjectIssuesList.vue?vue&type=script&lang=js"
import style0 from "./AutomaticProjectIssuesList.vue?vue&type=style&index=0&id=409b9097&prod&lang=scss&scoped=true"
import style1 from "./AutomaticProjectIssuesList.vue?vue&type=style&index=1&id=409b9097&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409b9097",
  null
  
)

export default component.exports